"use client";

// Error boundary route-level. Catches errors thrown in any route segment under app/.
// Reports to /api/logs/error so the maintenance agent can detect and diagnose.

import { useEffect } from "react";

export default function RouteError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    fetch("/api/logs/error", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: error.message,
        stack: error.stack,
        url: typeof window !== "undefined" ? window.location.href : "",
        component: "route-error-boundary",
      }),
    }).catch(() => { /* silent fail */ });
  }, [error]);

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h2>Une erreur est survenue</h2>
      <p style={{ color: "#666", marginBottom: "1rem" }}>
        L&apos;équipe technique a été notifiée.
      </p>
      <button
        onClick={reset}
        style={{
          padding: "0.5rem 1rem",
          background: "#0066cc",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Réessayer
      </button>
    </div>
  );
}
